var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fit"},[_c('div',{staticClass:"r-text-intro"},[_vm._v("שמחים שחזרת!")]),_c('enter-otp',{attrs:{"onValidOTP":_vm.validOTP,"onRequiredFieldMissing":_vm.missingRequiredField}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }